<template lang="pug">
  .summary
    .summary__line.summary__line_header
      .summary__title.summary__prod--caption
        p Product Name
      .summary__title.summary__prod--date
        p Date & Time 
      .summary__title
        p Quantity
      .summary__title
        p Price
      .summary__title
        p Sub Total
      .summary__title
        p Tax
      .summary__title
        p Total
    template(v-for="(card, index) in cards")
      .summary__line(:key="index")
        .summary__prod.summary__prod--left
          p {{ getCardTitle(card) }}
          template(v-for="(count, name) in card.upgrades || {}")
            p(v-if="count") {{ cardProduct(card).upgrades.find(x => x.name == name).title }} {{ count }}
        .summary__prod.summary__prod--left
        .summary__prod.summary__prod__quantity
          .summary__calc
            p.nowrap 1
          p.summary__price-sp.nowrap {{ getCardPrice(card) | currency }}
          p.summary__subtotal-price-hide.nowrap {{ getCardSubTotal(card) | currency }}
        .summary__prod.summary__prod__rate
          p.nowrap {{ getCardRate(card) | currency }}
        .summary__prod.summary__prod__sub-total
          p.nowrap {{ getCardSubTotal(card) | currency }}
        .summary__prod.summary__prod__tax
          p.nowrap {{ getCardTaxTotal(card) | currency }}
        .summary__prod.summary__prod--right.summary__prod__total.summary__prod--last
          p.nowrap {{ getCardTotal(card) | currency }}
    .summary__line-footer
      .summary__prod.summary__prod--right.summary__padd-right
        p.summary_show-mob Sub total
        p.nowrap {{ subTotal | currency }}
      .summary__prod
        p.summary_show-mob Tax
        p.nowrap {{ taxTotal | currency }}
      .summary__prod.summary__prod--right.summary__prod--total
        p.summary_show-mob Total
        p.nowrap {{ netTotal | currency }}
</template>

<script>
export default {
  name: 'mini-cart',

  props: {
    cards: {
      type: Array,
      require: true,
    },
    playcardProducts: {
      type: Array,
      require: true,
    }
  },

  data() { return {

  } },

  computed: {
    subTotal() {
      return _.reduce(this.cards, (total, card) => {
        return total + this.getCardSubTotal(card)
      }, 0)
    },
    taxTotal() {
      return _.reduce(this.cards, (total, card) => {
        return total + this.getCardTaxTotal(card)
      }, 0)
    },
    netTotal() {
      return this.subTotal + this.taxTotal
    },
  },
  methods: {
    cardProduct(card) {
      return this.playcardProducts.find(x => x.id == card.productId)
    },
    getCardTitle(card) {
      return this.cardProduct(card).title
    },
    getCardPrice(card) {
      const playcardProduct = this.cardProduct(card)
      return Number(playcardProduct.price) +
        Object.entries(card.upgrades)
            .map(([name, count]) => playcardProduct.upgrades.find(u => u.name == name).price * count)
            .reduce((sum, a) => sum + a, 0)
    },
    getCardRate(card) {
      return this.getCardPrice(card)
    },
    getCardSubTotal(card) {
      return this.getCardPrice(card)
    },
    getCardTaxTotal(card) {
      return Number(this.cardProduct(card).tax)
    },
    getCardTotal(card) {
      return this.getCardSubTotal(card) + this.getCardTaxTotal(card)
    },
  }
}
</script>

<style lang="scss">
</style>
